// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"74":"639f25ee","149":"9d5eb611","328":"c1f1ee59","488":"c4ebf0f1","588":"7c133171","975":"95d397d8"}[chunkId] + ".js";
};